// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Form from "../components/Form.bs.js";
import * as Liff from "../liff/Liff.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as Fetch from "bs-fetch/src/Fetch.bs.js";
import * as Tools from "../Tools.bs.js";
import * as React from "react";
import * as Button from "../components/Button.bs.js";
import * as Config from "../Config.bs.js";
import * as Layout from "../Layout.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as ProfileForm from "./ProfileForm.bs.js";
import * as ProfileContext from "./ProfileContext.bs.js";
import * as ProfileReducer from "./ProfileReducer.bs.js";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";

function addProfile(token, body) {
  var requestInit = Fetch.RequestInit.make(/* Post */2, {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json; charset=UTF-8"
        }, Caml_option.some(body), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
  return fetch(Config.url, requestInit).then(Tools.parseJsonIfOk);
}

function ProfileRegisterPage(Props) {
  var match = React.useState(function () {
        return false;
      });
  var setLoading = match[1];
  var liff = React.useContext(Liff.context);
  var match$1 = React.useContext(ProfileContext.context);
  var reducer = match$1.reducer;
  var dispatch = reducer.dispatch;
  var state = reducer.state;
  var lead_in_channel = match$1.lead_in_channel;
  var match$2 = React.useState(function () {
        
      });
  var validated_state = match$2[0];
  var handleSubmit = function (param) {
    if (validated_state !== undefined) {
      var body = JSON.stringify(ProfileReducer.toJson(validated_state, lead_in_channel));
      Curry._1(setLoading, (function (param) {
              return true;
            }));
      addProfile(liff.access_token, body).then(function (resp) {
            Curry._1(dispatch, {
                  TAG: /* ChangeState */0,
                  _0: state
                });
            var tmp;
            tmp = resp.TAG === /* Ok */0 ? RescriptReactRouter.push("/success") : RescriptReactRouter.push("/error");
            return Promise.resolve(tmp);
          });
    }
    
  };
  if (match[0]) {
    return React.createElement(Layout.Loading.make, {});
  } else {
    return React.createElement(Layout.Default.make, {
                children: null,
                hero: true
              }, React.createElement(ProfileForm.make, {
                    init_profile: state,
                    onValidateForm: match$2[1]
                  }), React.createElement(Form.GroupInput.make, {
                    children: React.createElement(Button.make, {
                          label: "ยืนยัน",
                          disabled: Belt_Option.isNone(validated_state),
                          onClick: handleSubmit
                        })
                  }));
  }
}

var make = ProfileRegisterPage;

export {
  addProfile ,
  make ,
  
}
/* Form Not a pure module */
